import { type FC } from 'react';

type RoleInfo = {
  _id: string;
  name: string;
  baseRole?: string;
};

type TeamRoleInfo = {
  role: RoleInfo;
  teamName: string;
  teamKey: string;
};

type RoleInfoTableProps = {
  directCustomRoles: RoleInfo[];
  teamRoles: TeamRoleInfo[];
  className?: string;
};

export const RoleInfoTable: FC<RoleInfoTableProps> = ({ directCustomRoles = [], teamRoles = [], className = '' }) => {
  const hasAnyRoles = directCustomRoles.length > 0 || teamRoles.length > 0;

  if (!hasAnyRoles) {
    return null;
  }

  return (
    <div className={className}>
      <table className="consolidationModal__attributesTable">
        <thead>
          <tr className="consolidationModal__tableHeader">
            <th className="consolidationModal__tableHeaderCell consolidationModal__tableHeaderCell--attributeKey">
              Role Name
            </th>
            <th className="consolidationModal__tableHeaderCell">Assigned Via</th>
          </tr>
        </thead>
        <tbody>
          {directCustomRoles.map((role: RoleInfo) => (
            <tr key={role._id}>
              <td className="consolidationModal__tableCell consolidationModal__tableCell--attributeKey">{role.name}</td>
              <td className="consolidationModal__tableCell">Direct</td>
            </tr>
          ))}
          {teamRoles.map((teamRole: TeamRoleInfo) => (
            <tr key={`${teamRole.teamKey}-${teamRole.role._id}`}>
              <td className="consolidationModal__tableCell consolidationModal__tableCell--attributeKey">
                {teamRole.role.name}
              </td>
              <td className="consolidationModal__tableCell">Team ({teamRole.teamName})</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
